import React from 'react';

const NavItem = props => {
  const { children, onSelect } = props;
  let properties = { className: 'nav-item' };

  if (onSelect) {
    properties.onClick = onSelect;
  }

  return (
    <div {...properties}>{children}</div>);
};

export default NavItem;